import { type FilterState } from './usePeopleFilters.types';

export function hasActiveFiltersInState(s: FilterState): boolean {
    return (
        s.keywordSearch !== '' ||
        s.activeTab !== 'all' ||
        s.places.length > 0 ||
        s.programTypes.length > 0 ||
        s.companies.length > 0 ||
        s.industries.length > 0 ||
        s.interests.length > 0 ||
        s.lookingFor.length > 0 ||
        s.timezones.length > 0 ||
        s.userIds.length > 0
    );
}
